import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DotsArrowRegularLeft from './dots-arrow-regular-left-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DotsArrowRegularLeft {...validProps} />;
}
SvgComponent.iconName = 'dotsArrowRegularLeft';

export const DotsArrowRegularLeftIcon = svgIconWrapper(SvgComponent);
